import api from './api';

const missionService = {
  // Récupérer toutes les missions avec filtres et pagination
  getMissions: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    // Ajouter les paramètres de requête
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/missions?${queryString}` : '/missions';
    
    return await api.get(url);
  },

  // Récupérer une mission par ID
  getMissionById: async (id) => {
    return await api.get(`/missions/${id}`);
  },

  // Créer une nouvelle mission
  createMission: async (missionData) => {
    return await api.post('/missions', missionData);
  },

  // Mettre à jour une mission
  updateMission: async (id, missionData) => {
    return await api.put(`/missions/${id}`, missionData);
  },

  // Supprimer une mission
  deleteMission: async (id) => {
    return await api.delete(`/missions/${id}`);
  },

  // Postuler à une mission
  applyToMission: async (id, applicationData) => {
    return await api.post(`/missions/${id}/apply`, applicationData);
  },

  // Récupérer les candidatures d'une mission
  getMissionApplications: async (id) => {
    return await api.get(`/missions/${id}/applications`);
  },

  // Accepter une candidature
  acceptApplication: async (missionId, applicationId) => {
    return await api.put(`/missions/${missionId}/applications/${applicationId}/accept`);
  },

  // Rejeter une candidature
  rejectApplication: async (missionId, applicationId) => {
    return await api.put(`/missions/${missionId}/applications/${applicationId}/reject`);
  },

  // Télécharger des médias pour une mission
  uploadMissionMedia: async (id, formData) => {
    return await api.put(`/missions/${id}/media`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Rechercher des missions par localisation
  searchByLocation: async (params) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    return await api.get(`/missions/search/location?${queryParams.toString()}`);
  },

  // Récupérer les missions de l'utilisateur connecté
  getUserMissions: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/missions/user/my-missions?${queryString}` : '/missions/user/my-missions';
    
    return await api.get(url);
  },

  // Mettre à jour le statut d'une mission
  updateMissionStatus: async (id, status) => {
    return await api.put(`/missions/${id}/status`, { status });
  },

  // Ajouter un avis sur une mission
  addMissionReview: async (id, reviewData) => {
    return await api.post(`/missions/${id}/review`, reviewData);
  },

  // Récupérer les avis d'une mission
  getMissionReviews: async (id) => {
    return await api.get(`/missions/${id}/reviews`);
  },

  // Récupérer les statistiques des missions
  getMissionStats: async () => {
    return await api.get('/missions/stats');
  },

  // Rechercher des missions (recherche textuelle)
  searchMissions: async (query, params = {}) => {
    const queryParams = new URLSearchParams({ q: query });
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    return await api.get(`/missions/search?${queryParams.toString()}`);
  }
};

export default missionService;